import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import api from "../../../lib/api";
import { API } from "../../../App";

// Phase 2A — Calendar data hook. Centralised so List + Calendar share invalidation.
export function useTasksCalendar(user, { fromDate, toDate, view, priorityGrade, department, relatedModule }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEvents = useCallback(async () => {
    if (!fromDate || !toDate) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({
        requester_role: user?.role || "",
        requester_name: user?.name || "",
        requester_user_id: user?.user_id || "",
        from_date: fromDate,
        to_date: toDate,
      });
      if (view) params.append("view", view);
      if (priorityGrade) params.append("priority_grade", priorityGrade);
      if (department) params.append("department", department);
      if (relatedModule) params.append("related_module", relatedModule);
      const res = await api.get(`${API}/crm/tasks/calendar?${params.toString()}`);
      setEvents(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, [user?.role, user?.name, user?.user_id, fromDate, toDate, view, priorityGrade, department, relatedModule]);

  useEffect(() => { fetchEvents(); }, [fetchEvents]);

  return { events, loading, refresh: fetchEvents };
}
